export function FormatQty(value) {
  if (value === '' || isNaN(value)) {
    return 0
  } else {
    return (
      '' +
      parseFloat(value)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
    )
  }
}

export function FormatCurrency2(value) {
  if (value === '' || isNaN(value)) {
    return 0.00
  } else {
    return String(
      '' +
      parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
    )
  }
}
